<template>
  <div class="category category-simple">
    <div class="category-title">
      <h3 class="tc-title">{{ category.name }}</h3>
      <div class="right-container">
        <div v-if="hasLegIntToggle" class="switch-container">
          <label v-if="settings.iabLegitimateInterestToggle">{{ $t('legitimateInterest') }}</label>
          <pc-checkbox-button
            v-if="settings.consentButtonStyle === 'button'"
            v-model="category.legitimateInterest"
            :label-on="settings.labelBtOn"
            :label-off="settings.labelBtOff"
            @input="emitConsentChanged"
          ></pc-checkbox-button>
          <pc-checkbox-native
            v-else-if="settings.consentButtonStyle === 'checkbox'"
            v-model="category.legitimateInterest"
            @input="emitConsentChanged"
          ></pc-checkbox-native>
          <pc-leg-switch
            v-else
            v-model="category.legitimateInterest"
            :settings="settings"
            :label-on="settings.labelBtOn"
            :label-off="settings.labelBtOff"
            @input="emitConsentChanged"
          ></pc-leg-switch>
        </div>
        <div v-if="!noConsent && hasConsentToggle" class="switch-container">
          <label v-if="settings.iabLegitimateInterestToggle">{{ $t('consent') }}</label>
          <pc-checkbox-button
            v-if="settings.consentButtonStyle === 'button'"
            v-model="category.consent"
            :aria-label="category.label"
            :label-on="settings.labelBtOn"
            :label-off="settings.labelBtOff"
            @input="emitConsentChanged"
          ></pc-checkbox-button>
          <pc-checkbox-native
            v-else-if="settings.consentButtonStyle === 'checkbox'"
            v-model="category.consent"
            @input="emitConsentChanged"
          ></pc-checkbox-native>
          <pc-leg-switch
            v-else
            v-model="category.consent"
            :settings="settings"
            :label-on="settings.labelBtOn"
            :label-off="settings.labelBtOff"
            @input="emitConsentChanged"
          ></pc-leg-switch>
        </div>
      </div>
    </div>
    <p class="category-description tc-description">{{ category.description }}</p>
    <div class="consent-footer">
      <a class="pointer" style="align-items:flex-end;" @click="displayLegal = !displayLegal">
        {{ $t('legals') }}
        <span v-show="displayLegal" class="glyphicon glyphicon-chevron-up" aria-hidden="true"></span>
        <span v-show="!displayLegal" class="glyphicon glyphicon-chevron-down" aria-hidden="true"></span>
      </a>
      <a class="pointer" v-if="$listeners['show-related-vendors']" @click="showRelatedVendors()">
        {{ settings.showRelatedVendorsText || $t('showRelatedVendors') }}
      </a>
    </div>
    <div class="description-legal" v-show="displayLegal">
      <p>{{ category.descriptionLegal }}</p>
    </div>
  </div>
</template>
<script>
import PcCheckboxButton from '@/components/forms/pc-checkbox-button';
import PcLegSwitch from '@/components/forms/pc-leg-switch';
import PcCheckboxNative from '@/components/forms/pc-checkbox-native';

import { i18nMixin } from 'shared/i18n/i18n-mixin';
import { eventEmitterMixin } from '@/common/messaging/event-emitter-mixin';
import { stripHtml } from '@/common/filters/strip-html';

export default {
  components: {
    PcCheckboxButton,
    PcLegSwitch,
    PcCheckboxNative,
  },
  mixins: [i18nMixin, eventEmitterMixin],

  props: {
    category: {
      type: Object,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
    noConsent: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      displayLegal: false,
    };
  },
  computed: {
    hasConsentToggle() {
      return !this.noConsent && this.category.isConsent;
    },
    hasLegIntToggle() {
      return (
        !this.noConsent &&
        this.category.isLegitimateInterest &&
        (this.settings.iabLegitimateInterestToggle || !this.hasConsentToggle)
      );
    },
  },
  watch: {
    'category.consent': function(value) {
      if (!this.settings.iabLegitimateInterestToggle && !this.hasLegIntToggle && this.category.isLegitimateInterest) {
        this.category.legitimateInterest = value;
      }
    },
  },

  methods: {
    stripHtml,
    showRelatedVendors() {
      this.$emit('show-related-vendors', { category: this.category, provider: 'iab' });
    },
  },
};
</script>
<style lang="scss" scoped>
.description-legal {
  padding: 2rem;
  white-space: pre-line;
}
.consent-footer {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}
.category {
  margin-bottom: 3rem;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
</style>
